import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// stock_transfers — ใบโอนสินค้า (Stock Transfer)
// ============================================================================
export const stockTransfers = sqliteTable("inventory_stock_transfers", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  transferNo: text("transfer_no").notNull().unique(),
  fromWarehouseId: text("from_warehouse_id").notNull(),
  toWarehouseId: text("to_warehouse_id").notNull(),
  postingDate: text("posting_date").notNull(),
  remarks: text("remarks"),
  docStatus: integer("doc_status").notNull().default(0), // 0=draft, 1=submitted, 2=cancelled
  referenceModule: text("reference_module"),
  referenceId: text("reference_id"),
  totalQty: real("total_qty").notNull().default(0),
  totalAmount: real("total_amount").notNull().default(0),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at"),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  st_company_date_idx: index("st_company_date_idx").on(table.companyId, table.postingDate),
  st_company_from_idx: index("st_company_from_idx").on(table.companyId, table.fromWarehouseId),
  st_company_to_idx: index("st_company_to_idx").on(table.companyId, table.toWarehouseId),
}));

export const stockTransferItems = sqliteTable("inventory_stock_transfer_items", {
  id: text("id").primaryKey(),
  stockTransferId: text("stock_transfer_id").notNull().references(() => stockTransfers.id),
  itemId: text("item_id").notNull(),
  qty: real("qty").notNull().default(0),
  rate: real("rate").notNull().default(0),
  amount: real("amount").notNull().default(0),
  remarks: text("remarks"),
}, (table) => ({
  sti_transfer_idx: index("sti_transfer_idx").on(table.stockTransferId),
  sti_item_idx: index("sti_item_idx").on(table.itemId),
}));

export type StockTransfer = typeof stockTransfers.$inferSelect;
export type NewStockTransfer = typeof stockTransfers.$inferInsert;
export type StockTransferItem = typeof stockTransferItems.$inferSelect;
export type NewStockTransferItem = typeof stockTransferItems.$inferInsert;
